import { createI18n } from 'vue-i18n';
import _ from 'lodash';
import LangEn from './lang-en';
import LangTh from './lang-th';

const en = _.merge(LangEn);
const th = _.merge(LangTh);

const i18n = createI18n({
    locale: 'th',
    allowComposition: true,
    messages: {
        en: en,
        th: th
    }
});

export default i18n;
